export default __webpack_public_path__ + "static/media/angular2.1448b422.webp";